var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Diverse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 9.12a28.88 28.88 0 10-.02 57.76A28.88 28.88 0 0038 9.12zm0 54A25.15 25.15 0 1163.15 38 25.18 25.18 0 0138 63.15v-.03zm17-25.44a4 4 0 11-8 0 4 4 0 018 0zm-13 0a4 4 0 11-8 0 4 4 0 018 0zm-13 0a4 4 0 11-8 0 4 4 0 018 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Diverse.f801ed30.svg";
export { SvgK1Diverse as ReactComponent };